import  './assets/fonts-material.css'
import Vue from 'vue';
import VueI18n from 'vue-i18n'
import singleSpaVue from 'single-spa-vue';
import VueMaterial from 'vue-material'
import Axios from 'axios'
import momentTz from 'moment-timezone'
import security from '@/security'
import App from './App.vue';
import router from './router';
import store from './store'


// set default css
import '@/assets/base.scss'
import 'vue-material/dist/vue-material.min.css'

import i18n from './i18n'

import products from '@/brand/products'

import roles from './utils/roles'

Vue.prototype.$roles = roles

Vue.config.productionTip = false;

// uses
Vue.use(VueI18n)
Vue.use(VueMaterial)


Vue.component('list-role', () => import('./components/Menu/ListRole'))
Vue.component('list-role-item', () => import('./components/Menu/ListRoleItem'))
Vue.component('sub-list-role', () => import('./components/Menu/SubListRole'))
Vue.component('md-dialog-confirm', () => import('./components/MdDialog/MdDialogConfirm'))

// Axios
Vue.prototype.$http = Axios
Axios.defaults.baseURL = process.env.VUE_APP_URL_SERVER_BASE
Axios.defaults.headers.common['timeZone'] = momentTz.tz.guess()
Axios.defaults.headers.get['Pragma'] = 'no-cache'
Axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'

// i18n
const language = window.navigator.userLanguage || window.navigator.language
i18n.setLanguage(language)
Vue.prototype.$languages = () => {
    return i18n
}

Vue.prototype.$productObject = products.getClientObject()

Axios.interceptors.response.use(response => {
    return response
}, async error => {
    if (error && error.response && error.response.status) {
        const status = typeof error === 'object' ? (error.response && error.response.status ? error.response.status : 0) : error
        if (status === 401) {
            // desloga e redireciona pra tela de login
            store.dispatch('Auth/signout')
        } else if (status === 403) {
            store.dispatch('Global/showMessage', 'accessDeniedError')
        } else if (status === 503 || status === 429) {
            store.dispatch('Global/showMessage', 'errorDefault')
        } else if (status === 400) {
            store.dispatch('Global/showMessage', 'errorBadRequest')
        } else if (status === 404) {
            store.dispatch('Global/showMessage', 'errorNotFound')
        } else if (status === 409) {
            store.dispatch('Global/showMessage', 'conflictError')
        } else if (status === 415) {
            store.dispatch('Global/showMessage', 'mediaError')
        } else if (status !== 404 && status !== 422 && status >= 400) {
            store.dispatch('Global/showMessage', 'unexpectedError')
        }
    }
    return Promise.reject(error)
})

// Axios Interceptors
Axios.interceptors.request.use(async config => {
    // se tiver autenticado, adiciona access_token ao request
    let user = await security.getUser()
    if (user) {
        const authToken = user.access_token
        if (authToken) {
            config.headers.Authorization = `Bearer ${authToken}`
        }
    }
    return config
})

const vueLifecycles = singleSpaVue({
    Vue,
    appOptions: {
        render: h => h(App),
        router,
        store,
        i18n
    },
});

export const bootstrap = vueLifecycles.bootstrap;
export const mount = vueLifecycles.mount;
export const unmount = vueLifecycles.unmount;
